import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

import { IPublicationViewMessages } from '../../../../../types';
import { styles } from './ReportEmbedsPopulatingLoader.styles';

export const EmbedPopulationProcessLoader = ({ messages }: { messages: IPublicationViewMessages }) => {
  return (
    <Box role="status" aria-live="polite" aria-label="Loading report embeds" sx={styles.loadingContainer}>
      <CircularProgress data-test="embed-population-loading-spinner" aria-label="Loading" />
      <Box sx={styles.populatingEmbedLabel}>
        <Typography variant="body2">{messages.populatingPublicationsEmbeds}</Typography>
      </Box>
    </Box>
  );
};
